import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';
import { StudentsRemovalRequestHistoryFilters } from './StudentsRemovalRequestHistoryFilters';
import { StudentsRemovalRequestHistoryFiltersLoader } from './StudentsRemovalRequestHistoryFiltersLoader';
import {
  StudentsRemovalRequestHistoryListConsumer,
  StudentsRemovalRequestHistoryListLoader,
} from './StudentsRemovalRequestHistoryListLoader';
import { StudentsRemovalRequestHistoryTable } from './StudentsRemovalRequestHistoryTable';
import { StudentsRemovalRequestHistoryTablePagination } from './StudentsRemovalRequestHistoryTablePagination';

export function StudentsRemovalRequestHistory() {
  const { t } = useTranslation(
    TranslationsKeys.STUDENT_MANAGEMENT_STUDENT_REMOVAL_REQUEST_HISTORY,
  );
  const texts = useMemo(() => {
    return {
      body: t('history.body'),
    };
  }, [t]);
  return (
    <>
      <p>{texts.body}</p>
      <StudentsRemovalRequestHistoryFiltersLoader>
        {({ data }) => (
          <StudentsRemovalRequestHistoryListLoader>
            <StudentsRemovalRequestHistoryFilters data={data} />
            <StudentsRemovalRequestHistoryListConsumer>
              {({ data, loading }) => {
                return (
                  <>
                    <StudentsRemovalRequestHistoryTable
                      data={data?.data ?? []}
                      loading={loading}
                    />
                    {!!data && !loading && data.total_pages > 1 && (
                      <StudentsRemovalRequestHistoryTablePagination
                        total={data.total}
                        totalPages={data.total_pages}
                      />
                    )}
                  </>
                );
              }}
            </StudentsRemovalRequestHistoryListConsumer>
          </StudentsRemovalRequestHistoryListLoader>
        )}
      </StudentsRemovalRequestHistoryFiltersLoader>
    </>
  );
}
